import { render, staticRenderFns } from "./supplierTable.vue?vue&type=template&id=78adb61d&"
import script from "./supplierTable.vue?vue&type=script&lang=js&"
export * from "./supplierTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports